export default "__VITE_ASSET__DwpDULzO__"